<script setup lang="ts">
import "./MToggle.scss";
import type { MToggleProps } from "./MToggle.props";
import { mToggleDefaults } from "./MToggle.props";
import { useFormValue } from "../../../../composables/namedValue";
import { randomID } from "../../../../utils/helpers";

const props = withDefaults(defineProps<MToggleProps>(), mToggleDefaults);

const templateValue = useFormValue(props);
const inputId = randomID("toggle");
</script>

<template>
  <span class="m-toggle">
    <input
      :id="inputId"
      v-model="templateValue"
      :aria-label="ariaLabel"
      type="checkbox"
      role="switch"
      class="m-toggle__input"
    />
    <label :for="inputId" class="m-toggle__label">
      <span class="m-toggle__track" aria-hidden="true">
        <span class="m-toggle__thumb" />
      </span>
      <span v-if="label" class="m-toggle__text">{{ label }}</span>
    </label>
  </span>
</template>
